import { CONTACT } from "../siteConfig";

// 공통 푸터: 로고·회사명 / SITEMAP / CONTACT / 저작권
export default function Footer() {
  return (
    <footer className="ib-footer">
      <div className="ib-wrap ib-footer__top">
        <div className="ib-footer__brand">
          <img src="/assets/img/common/inba_logo.png" alt="INBA International Bridge & Access" width="132" height="40" />
          <p>
            INBA (Thailand) Co., Ltd.
            <br />
            한국과 태국을 연결하고, 현장에서 실행하는 비즈니스 파트너
          </p>
        </div>
        <div>
          <span className="ib-footer__label">SITEMAP</span>
          <nav className="ib-footer__nav" aria-label="사이트맵">
            <a href="/">HOME</a>
            <a href="/about">ABOUT INBA</a>
            <a href="/business">BUSINESS</a>
            <a href="/portfolio">PORTFOLIO</a>
            <a href="/brands">OUR BRANDS</a>
            <a href="/contact">CONTACT</a>
          </nav>
        </div>
        <div>
          <span className="ib-footer__label">CONTACT</span>
          <div className="ib-footer__contact">
            <span>
              <b>EMAIL</b>
              <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
            </span>
            <span>
              <b>THAILAND</b>
              <a href={`tel:${CONTACT.phoneThailand.tel}`}>{CONTACT.phoneThailand.label}</a>
            </span>
            <span>
              <b>OFFICES</b>Bangkok · Suwon
            </span>
          </div>
        </div>
      </div>
      <div className="ib-wrap ib-footer__bottom">
        <span>© 2026 INBA (Thailand) Co., Ltd. All rights reserved.</span>
        <span>KOREA × THAILAND / BUSINESS IN MOTION</span>
      </div>
    </footer>
  );
}
